import type {
  ScaleConnectionType,
  ScaleFormatType,
  ScaleMeasurementMode,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const scaleUpdateAtom = createMutationAtomFactory(
  'settings.scaleUpdate',
  (params: {
    id: string;
    name?: string;
    connectionType?: ScaleConnectionType;
    serialPortPath?: string | null;
    baudRate?: number | null;
    dataBits?: number | null;
    stopBits?: string | null;
    parity?: string | null;
    tcpHost?: string | null;
    tcpPort?: number | null;
    scaleFormatType?: ScaleFormatType;
    measurementMode?: ScaleMeasurementMode;
    onDemandString?: string | null;
    unitOfMeasurement?: string | null;
    cameraId?: string | null;
  }) => ({
    iotScaleUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          cameraId: params.cameraId,
          connectionType: params.connectionType,
          serialPortPath: params.serialPortPath,
          baudRate: params.baudRate,
          dataBits: params.dataBits,
          stopBits: params.stopBits,
          parity: params.parity,
          tcpHost: params.tcpHost,
          tcpPort: params.tcpPort,
          scaleFormatType: params.scaleFormatType,
          measurementMode: params.measurementMode,
          onDemandString: params.onDemandString,
          unitOfMeasurement: params.unitOfMeasurement,
        },
      },
      id: true,
      name: true,
      connectionType: true,
      serialPortPath: true,
      baudRate: true,
      dataBits: true,
      stopBits: true,
      parity: true,
      tcpHost: true,
      tcpPort: true,
      scaleFormatType: true,
      measurementMode: true,
      onDemandString: true,
      status: true,
    },
  }),
);
